/*
 * 機能別コンポーネント 発注検索パネル画面で使用するconst・interface・types
 * ・更新履歴
 */

// 下部ボタン項目情報
export const underButtonArray = [
  {
    name: "search",
    color: "secondary",
    value: "検索"
  },
  {
    name: "clear",
    color: "secondary",
    value: "クリア",
    // text: true
  }
];
